export const applicationConfig = {
    baseUrl: '/customer/searches',
    apiRegistryUrl: '/api/brief/registry',
};
